import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Ionicons } from "@expo/vector-icons";
import { differenceInWeeks } from "date-fns";
import Colors from "../../../Resources/Color";
import GlobalStyles from "../../../Resources/Styles";

const CompetitionCard = observer(({ client }) => {
  const { t } = useTranslation();

  if (!client || !client.competitions) return null;

  const summaryStartDate = client.summaryStartDate;
  if (!summaryStartDate) return null;

  const summaryEndDate = new Date(summaryStartDate);
  summaryEndDate.setDate(summaryEndDate.getDate() + 7);

  const competitionsInFuture = client.competitions
    .filter((comp) => {
      const compDate = new Date(comp.date);
      // Only show competitions that are in the future (from the end of the summary week onwards)
      return compDate >= summaryStartDate;
    })
    .sort((a, b) => new Date(a.date) - new Date(b.date));

  const earliestCompetition =
    competitionsInFuture.length > 0 ? competitionsInFuture[0] : null;

  if (!earliestCompetition) return null;

  const compDate = new Date(earliestCompetition.date);

  // Check if competition is in the current summary week
  const isThisWeek = compDate >= summaryStartDate && compDate < summaryEndDate;

  const weeksOut = differenceInWeeks(compDate, summaryStartDate);

  const handlePress = () => {
    client.coach.setSelectedClientComp(client);
    client.setSelectedCompetition(earliestCompetition);
    client.coach.setProperty("showingCoachView", "CoachCompetitions");
    client.coach.unselectClient();
  };

  // Format the weeks out text
  let weeksOutText;
  if (isThisWeek) {
    weeksOutText = t("thisWeek-string");
  } else if (weeksOut === 1) {
    weeksOutText = t("oneWeekOut-string");
  } else {
    weeksOutText = `${weeksOut} ${t("weeksOut-string")}`;
  }

  return (
    <TouchableOpacity style={GlobalStyles.Card} onPress={handlePress}>
      <View style={GlobalStyles.CardHeader}>
        <View style={GlobalStyles.CardHeaderMain}>
          <View style={GlobalStyles.CardIcon}>
            <Ionicons
              name="podium-outline"
              size={20}
              color={Colors.grayColor}
            />
          </View>
          <Text style={GlobalStyles.CardTitle}>
            {t("nextCompetition-string")}
          </Text>
        </View>
        <Ionicons name="chevron-forward" size={16} color={Colors.grayColor} />
      </View>

      <View style={styles.competitionContent}>
        <Text style={styles.compName} numberOfLines={2}>
          {earliestCompetition.name}
        </Text>
        <Text style={styles.compMeta}>· {weeksOutText}</Text>
      </View>
    </TouchableOpacity>
  );
});

const styles = StyleSheet.create({
  competitionContent: {
    flexDirection: "row",
    alignItems: "baseline",
    gap: 8,
    alignItems: "center",
  },
  compName: {
    fontSize: 14,
    fontWeight: "500",
    color: Colors.blackColor,
    flexShrink: 1,
  },
  compMeta: {
    fontSize: 12,
    flexShrink: 0,
    color: Colors.grayColor,
  },
});

export default CompetitionCard;
